<template>
  <ul class="grid product-grid">
    <li
      v-for="(product, i) in productDataset.products"
      :id="'product_' + i"
      :key="product.id"
      v-view="onceHandler"
      :data-id="i"
      :class="{ 'is-doble-row': product.is_featured === true }"
    >
      <article>
        <div class="product-item">
          <span :class="['product-badge plp', product.productbadgtext ? '' : 'hide-badge']">{{
            product.productbadgtext
          }}</span>
          <div class="product-item-box">
            <div class="product-item-image">
              <media-image
                :filename="product.image.filename"
                :resolutions="product.image.resolutions"
                :alt="product.image.alt"
                :sizes="product.image.sizes"
                :fallback-size="product.image['fallback-size']"
                :lazy="true"
                :ratio="product.image.ratio"
              >
              </media-image>
            </div>

            <template v-if="product.is_featured === true">
              <div class="product-item-info">
                <a v-tag="product.tagging_click" :href="product.url">
                  <div class="product-item-container">
                    <p class="product-name" @click="filterDataLayer(product.tagging_click)">
                      {{ product.title.replace(/&amp;#39;/g, "'") }}
                    </p>
                    <span
                      v-if="product.product_price"
                      class="routine-price-text"
                      @click="filterDataLayer(product.tagging_click)"
                      >{{ product.product_price }}</span
                    >
                    <a
                      v-if="productDataset.Products_enableordisable"
                      :href="product.url"
                      aria-label="Product ratings"
                    >
                      <star-rating
                        :increment="1"
                        :max-rating="5"
                        inactive-color="#e0e0e0"
                        active-color="#242424"
                        :star-size="15"
                        :rating="product.Overall_ProductRating"
                        :read-only="true"
                        :show-rating="false"
                        :star-ratings-taging="product.TaggingRatesAndReviewsAttributes"
                      >
                      </star-rating
                      ><span>{{ product.Overall_ProductRating }}/5</span
                      ><span>
                        ({{ product.Total_RatingCount }} {{ productDataset.Review_Text }})</span
                      >
                    </a>
                    <div
                      v-if="Enable_Bv"
                      data-bv-show="inline_rating"
                      :data-bv-product-id="product.product_ean"
                      data-bv-seo="false"
                    ></div>
                    <div
                      class="featured-product-content"
                      @click="filterDataLayer(product.tagging_click)"
                    >
                      <p class="product-description">
                        {{ product.summary.replace(/&amp;#39;/g, "'") }}
                      </p>
                      <p class="featured-product-link">{{ product.link_text }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </template>
            <template v-else>
              <div
                class="product-item-info"
                @click="filterDataLayer(product.tagging_product_filter_cumulate)"
              >
                <a :href="product.url" @click="filterDataLayer(product.tagging_click)">
                  <div role="presentation">
                    <div class="product-image-description">
                      <span class="image-description-block">{{
                        productDataset.filter_data.hover_state
                      }}</span>
                      <span
                        class="color-border-bar"
                        :style="{ 'background-color': product.collection_color }"
                      ></span>
                    </div>
                  </div>
                  <p class="product-subtitle">
                    {{ product.desired_results_concatenated.replace(/&amp;#39;/g, "'") }}
                  </p>
                  <p class="product-subtitle-hidden">
                    {{ product.desired_results.replace(/&amp;#39;/g, "'") }}
                  </p>
                  <div
                    class="product-color-bar"
                    :style="{ 'background-color': product.collection_color }"
                  ></div>
                  <h2 class="product-name">{{ product.title.replace(/&amp;#39;/g, "'") }}</h2>
                  <span v-if="product.product_price" class="routine-price-text">{{
                    product.product_price
                  }}</span>
                </a>
                <a
                  v-if="productDataset.Products_enableordisable"
                  :href="product.url"
                  aria-label="Product ratings"
                >
                  <star-ratings
                    :rating="product.Overall_ProductRating"
                    :star-rating-increment-value="1"
                    :star-rating-max-rating-value="5"
                    star-rating-inactive-color="#e0e0e0"
                    star-rating-active-color="#242424"
                    :star-rating-star-size="15"
                    :star-ratings-taging="product.tagging_product_rating_reviews"
                    :counts="product.Total_RatingCount"
                    :review-text="productDataset.Review_Text"
                  >
                  </star-ratings>
                </a>
                <div
                  v-if="Enable_Bv"
                  data-bv-show="inline_rating"
                  :data-bv-product-id="product.product_ean"
                  data-bv-seo="false"
                ></div>
                <p class="product-description">{{ product.summary.replace(/&amp;#39;/g, "'") }}</p>
              </div>
            </template>
          </div>
        </div>
        <div
          v-if="productDataset.Display_Mode === 'Popup' && product.is_featured === false"
          class="mctb_mc_05_"
        >
          <div>
            <div
              v-if="
                productDataset.MultipleClickToBuy_enableordisable && product.retailer.length != 0
              "
              style="cursor: pointer"
            >
              <a
                class="product-button ripple-animation ripple-animation--black"
                @click="popUpEnable(product.ProductItemId, product)"
                >{{ productDataset.MultipleClickToBuy_Text }}</a
              >
            </div>
            <span
              v-if="
                productDataset.Display_View === 'Carousel' &&
                showPopUp &&
                productDataset.MultipleClickToBuy_enableordisable &&
                product.retailer.length != 0
              "
            >
              <div
                class="mctb_popup_03_ mctb-modal-mask"
                style="background-color: rgb(0 0 0 / 6%); top: 3% !important"
              >
                <div class="mctb_popup_04_ mctb-modal-wrapper">
                  <div
                    class="mctb_popup_05_ mctb-modal-container"
                    style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
                  >
                    <div class="mctb_popup_06_ mctb-carousel-mode-header">
                      <button class="mctb_popup_07_ mctb-modal-close" @click="popUpDisable">
                        X
                      </button>

                      <div class="mctb_popup_08_ mctb-carousel-mode-header-top-header">
                        {{ productDataset.MctbRetailerHeader_Text }}
                      </div>

                      <template v-for="(retaildata, ri) in productDataset.products">
                        <mctb-carousel
                          v-if="filterProductid === retaildata.ProductItemId"
                          :key="ri"
                        >
                          <mctb-slide
                            v-for="(retailfulldata, index) in retaildata.retailer"
                            :key="index"
                          >
                            <div class="mctb_popup_09_ mctb-slider-outer">
                              <div
                                class="mctb_popup_10_ mctb-slider-description mctb-image-alignment"
                              >
                                <img
                                  class="mctb_popup_11_ mctb-button-image"
                                  :src="retailfulldata.retailer_logo"
                                  :alt="retailfulldata.retailer_name"
                                />
                              </div>
                              <p
                                class="mctb_popup_12_ mctb-slider-description"
                                v-html="retailfulldata.retailer_description"
                              ></p>
                              <button
                                class="mctb_popup_13_ mctb-popupcommon-buynow"
                                @click="
                                  pageRedirectUrl(
                                    retailfulldata.retailer_url,
                                    retailfulldata.new_window,
                                    retailfulldata,
                                  )
                                "
                              >
                                <span class="mctb_popup_14_ mctb-button-text">
                                  {{ retailfulldata.retailer_name }}</span
                                >
                              </button>
                            </div>
                          </mctb-slide>
                        </mctb-carousel>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </span>
            <span
              v-if="
                productDataset.Display_View === 'Default - PopupMode Only' &&
                showPopUp &&
                productDataset.MultipleClickToBuy_enableordisable &&
                product.retailer.length != 0
              "
            >
              <div
                class="mctb_popup_03_ mctb-modal-mask"
                style="background-color: rgb(0 0 0 / 6%); top: 3% !important"
              >
                <div class="mctb_popup_04_ mctb-modal-wrapper">
                  <div
                    class="mctb_popup_05_ mctb-modal-container"
                    style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
                  >
                    <div class="mctb_popup_06_ mctb-carousel-mode-header">
                      <button class="mctb_popup_07_ mctb-modal-close" @click="popUpDisable">
                        X
                      </button>

                      <div class="mctb_popup_08_ mctb-carousel-mode-header-top-header">
                        {{ productDataset.MctbRetailerHeader_Text }}
                      </div>

                      <template v-for="(retaildata, ri) in productDataset.products">
                        <ul
                          v-if="filterProductid === retaildata.ProductItemId"
                          :key="ri"
                          class="mctb-retailer-list"
                        >
                          <li v-for="(retailfulldata, index) in retaildata.retailer" :key="index">
                            <a class="mctb_popup_09_ mctb-retailer-item">
                              <div class="mctb_popup_10_ mctb-retailer-image">
                                <img
                                  class="mctb_popup_11_"
                                  :src="retailfulldata.retailer_logo"
                                  :alt="retailfulldata.retailer_name"
                                />
                              </div>
                              <p
                                class="mctb_popup_12_ mctb-slider-description"
                                v-html="retailfulldata.retailer_description"
                              ></p>
                              <button
                                class="mctb_popup_13_ mctb-retailer-buynow"
                                @click="
                                  pageRedirectUrl(
                                    retailfulldata.retailer_url,
                                    retailfulldata.new_window,
                                    retailfulldata,
                                  )
                                "
                              >
                                <span class="mctb_popup_14_">
                                  {{ retailfulldata.retailer_name }}</span
                                >
                              </button>
                            </a>
                          </li>
                        </ul>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </div>
        </div>

        <div
          v-if="
            !isBuynowVisible &&
            productDataset.purchase_buttonenableordisable &&
            product.Purchase_Link !== null
          "
        >
          <a
            :href="product.Purchase_Link.Url"
            target="_blank"
            class="product-button ripple-animation ripple-animation--black"
            @click="ctaRedirect(product)"
            >{{ product.link_text }}</a
          >
        </div>
        <template v-if="isBuynowVisible">
          <div v-if="product.ProductItemId">
            <button
              class="product-button ripple-animation ripple-animation--black plp-buy-now"
              @click="openCommercePopup(product.ProductItemId)"
            >
              {{ productDataset.buy_text }}
            </button>
          </div>
          <product-purchase
            :add-to-cart-tagging="product.add_to_cart_tagging"
            :list-price-template="productDataset.list_price_template"
            :price-template="productDataset.price_template"
            :single-price-template="productDataset.single_price_template"
            :installments-template="productDataset.installments_template"
            :discounts-template="productDataset.discounts_template"
            :unavailable-text="productDataset.unavailable_text"
            :buy-text="productDataset.buy_text"
            :api-url="productDataset.api_url"
            :ean="product.vtex_product_ean"
          />
        </template>
      </article>
    </li>
    <div v-if="isBuynowVisible" class="product-buynow">
      <commerce-connector ref="commercePopUp" :show="false" />
    </div>
  </ul>
</template>

<script>
const DEFAULT_PER_PAGE = 1;
import StarRating from 'vue-star-rating';
import Vue from 'vue';
import checkView from 'vue-check-view';
import { mapGetters } from 'vuex';
import CommerceConnector from '../commerce-connector/commerce-connector.vue';

Vue.use(checkView);

export default {
  name: 'grid',
  components: {
    StarRating,
    CommerceConnector,
  },
  props: {
    productDataset: { type: Object, required: true },
    Enable_Bv: { type: Boolean, default: true },
  },
  data() {
    return {
      filterProductid: '',
      showPopUp: false,
      lastIndex: -1,
      perPage: this.getPerPage(),
      bufferArrayItem: [],
      currentProducts: [],
    };
  },
  watch: {
    productDataset: {
      handler: function (latest) {
        this.currentProducts = latest.products;
      },
      immediate: true,
    },
  },
  mounted() {
    this.perPage = this.getPerPage();
    this.currentProducts = this.productDataset.products;
    if (window.eventBus) {
      window.eventBus.$on('mediaquery.changed', () => {
        this.perPage = this.getPerPage();
      });
      window.eventBus.$on('on-filter-update', () => {
        this.lastIndex = -1;
        this.bufferArrayItem = [];
        setTimeout(() => {
          window.scrollTo(0, 16);
        }, 200);
      });
    }
    setTimeout(() => {
      window.scrollTo(0, 10);
    }, 200);
  },
  computed: {
    filterProducts() {
      return this.currentProducts;
    },
    isBuynowVisible() {
      return this.productDataset.is_ecommerce_enabled;
    },
    ...mapGetters('purchase', ['products']),
  },
  methods: {
    openCommercePopup(itemID) {
      if (!itemID || !this.$refs) return;
      this.$refs.commercePopUp.getRetailers(itemID);
    },
    popUpEnable(ProductItemId, Product) {
      try {
        dataLayer.push({
          event: 'uaevent',
          event_name: 'buy_now',
          eventCategory: 'Ecommerce',
          eventAction: 'click to buy',
          eventLabel: `${Product.title.toLowerCase()}::${Product.product_ean || 'none'}`,
          product_info: `${Product.title.toLowerCase()}::${Product.product_ean || 'none'}`,
          ecommerce: undefined,
        });
      } catch (error) {
        console.warn(error);
      }
      this.showPopUp = true;
      this.filterProductid = ProductItemId;
    },
    popUpDisable() {
      this.showPopUp = false;
    },
    taggingFeaturedproduct(data) {
      try {
        dataLayer.push(data);
      } catch {
        console.warn(data);
      }
    },
    pageRedirectUrl(redirectURL, newWindow, retailfulldata) {
      try {
        let dimension35 = '';
        const data = retailfulldata.product_size.split('/');
        if (data && data.length) {
          dimension35 = data[0];
        }
          dataLayer.push({ //eslint-disable-line
          event: 'addToCart',
          event_name: 'add_to_cart',
          eventCategory: 'Ecommerce',
          eventAction: `redirection::${retailfulldata.retailer_name.toLowerCase().trim()}`,
          eventLabel: `${retailfulldata.product_name.toLowerCase().trim()}::${retailfulldata.product_ean || 'none'}`,
          product_info: `${retailfulldata.product_name.toLowerCase().trim()}::${retailfulldata.product_ean || 'none'}`,
          step: 'redirection',
          store_name: `${retailfulldata.retailer_name.toLowerCase().trim()}`,
          ecommerce: {
            add: {
              products: [
                {
                  name: retailfulldata.product_name.toLowerCase().trim(),
                  id: retailfulldata.product_ean || 'none',
                  quantity: 1,
                  brand: 'KER',
                  category: retailfulldata.product_category.toLowerCase(),
                  price: retailfulldata.price || 'none',
                  dimension35: dimension35.toLowerCase().trim() || 'none',
                  dimension36: 'none',
                  dimension38: retailfulldata.product_rating,
                  dimension48: retailfulldata.product_ean || 'none',
                  dimension59: retailfulldata.product_review,
                  dimension91: 'none',
                },
              ],
            },
          },
        });
      } catch (error) {
        console.warn(error);
      }
      /* istanbul ignore next line */
      if (newWindow === true) {
        window.open(redirectURL, '_blank');
      } else {
        window.open(redirectURL, '_self');
      }
    },
    ctaRedirect(product) {
      try {
        dataLayer.push({
          event: 'uaevent',
          event_name: 'buy_now',
          ecommerce: 'undefined',
          eventCategory: 'Ecommerce',
          eventAction: 'click to buy',
          eventLabel: `${product.title.toLowerCase().trim()}::${product.product_ean || 'none'}`,
          product_info: `${product.title.toLowerCase().trim()}::${product.product_ean || 'none'}`,
        });
      } catch (error) {
        console.warn(error);
      }
    },

    getPerPage() {
      let perPage = DEFAULT_PER_PAGE;

      /* istanbul ignore next */
      if (window.ScreenSizeHandler) {
        if (window.ScreenSizeHandler.getMqForSize('small').selected) {
          perPage = 1;
        }

        if (window.ScreenSizeHandler.getMqForSize('medium').selected) {
          perPage = 2;
        }

        if (window.ScreenSizeHandler.getMqForSize('large').selected) {
          perPage = 3;
        }
      }
      window.eventBus.$emit('perPage', perPage);
      return perPage;
    },
    filterDataLayer(datas) {
      // NOSONAR
      if (datas != null) {
        const dataLayerObject = JSON.stringify(datas);
        dataLayer.push(JSON.parse(dataLayerObject));
        dataLayer.forEach((data) => {
          if (data.eventAction == 'Product Click') {
            data.ecommerce.impressions.forEach((impression) => {
              this.products.forEach((el) => {
                if (Number(el.ean) == Number(impression.id)) {
                  if (Number(el.quantity) > 0) {
                    impression['price'] = el.price.list;
                  }
                }
              });
            });
          }
        });
        this.$forceUpdate();
      }
    },
    triggerDataLayer(index) {
      const id = `${'product_'}${index}`;
      const li = document.getElementById(id);
      const product = this.filterProducts;
      if (this.lastIndex < index && product[index]) {
        this.bufferArrayItem.push(product[index]);
        this.lastIndex = index;
      }
      const classnames = li.className;
      const perrow = this.perPage === 1 ? this.perPage : this.perPage - 1;
      const rowlength = classnames.includes('is-doble-row') ? perrow : this.perPage;
      if (this.bufferArrayItem.length === rowlength || this.lastIndex === product.length - 1) {
        this.triggerTaggingEvent(this.bufferArrayItem);
      }
    },
    onceHandler(e) {
      const index = Number(e.target.element.dataset.id);
      if (e.type === 'progress' && e.percentInView > 0.5 && this.lastIndex < index) {
        setTimeout(() => this.triggerDataLayer(index), 1000);
      }
    },
    triggerTaggingEvent(taggingItems) {
      // NOSONAR
      const impressions = [];

      taggingItems.forEach((taggingItem) => {
        const { ecommerce } = taggingItem.tagging_impression;

        if (ecommerce && ecommerce.impressions && ecommerce.impressions.length) {
          const productTaggingDetails = ecommerce.impressions[0];
          impressions.push({
            brand: productTaggingDetails.brand,
            category: productTaggingDetails.category,
            id: productTaggingDetails.id || 'none',
            price: productTaggingDetails.price || 'none',
            list: productTaggingDetails.list,
            name: productTaggingDetails.name,
            position: productTaggingDetails.position,
            variant: decodeURI(productTaggingDetails.variant),
            dimension35: decodeURI(productTaggingDetails.dimension35),
            dimension36: productTaggingDetails.dimension36,
            dimension38: productTaggingDetails.dimension38,
            dimension48: productTaggingDetails.dimension48,
            dimension59: productTaggingDetails.dimension59,
            dimension91: 'none',
          });
        }
      });

      const { eventLabel, eventCategory } = taggingItems[0].tagging_impression;
      const currencyCode = taggingItems[0].tagging_impression.ecommerce.currencyCode || 'none';
      try {
          dataLayer.push({ //eslint-disable-line
          event: 'nievent',
          event_name: 'view_item_list',
          eventCategory: eventCategory,
          eventAction: 'Product Impressions',
          eventLabel: eventLabel,
          ecommerce: {
            currencyCode: currencyCode,
            impressions: [],
            product: impressions,
          },
        });
      } catch {
        console.warn('datalayer is not defined');
      }

      dataLayer.forEach((data) => {
        if (data.eventAction == 'Product Impressions') {
          data.ecommerce.impressions.forEach((impression) => {
            this.products.forEach((el) => {
              if (Number(el.ean) == Number(impression.id)) {
                if (Number(el.quantity) > 0) {
                  impression['price'] = el.price.list;
                }
              }
            });
          });
        }
      });
      this.$forceUpdate();
      this.bufferArrayItem = [];
    },
    starTagging(values1, values2, values3, values4, values5) {
      dataLayer.push({
        eventCategory: values1,
        eventAction: values2,
        eventLabel: values3,
        event: values4,
        Ecommerce: values5,
      });
    },
  },
};
</script>

<style lang="scss" src="./grid.scss"></style>
